import { Box } from "@mui/material";
import React from "react";
import { path } from "src/constants/path";
import {
  allowedToDeleteEntity,
  allowedToReadEntity,
  allowedToUpdateEntity,
} from "src/constants/role";
import { dataStateType } from "src/constants/status";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useAuth from "src/hooks/useAuth";
import { categoryColumns as columns, showHomeScreen } from "../../Helper";
import Controls from "src/components/form/controls/Controls";
import { isOpenPopup } from "src/utils/isOpenPopup";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const GetCategoryColumns = ({
  handleDelete,
  handleOpenPopup,
  handleDisplayHomeScreen,
  status,
}) => {
  const { auth } = useAuth();
  const history = useHistory();

  const permissionsAccessControl = useGetPermissionAccessControl();

  const showDeviceCategory = (category) => {
    history.push(`${path.flfDevice}?page=1&categoryId=${category.id}`);
  };

  const showHomeScreenCol = {
    key: "showOnHomepage",
    label: "Show On Homepage",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <Controls.Select
            name="isDisplayHomeScreen"
            value={item.isDisplayHomeScreen ? "show" : "hide"}
            onChange={handleDisplayHomeScreen(item)}
            options={showHomeScreen}
          />
        )}
      </Box>
    ),
  };

  const actionCol = {
    key: "actions",
    label: "Actions",
    align: "center",
    render: (item) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          minWidth: "120px",
        }}
      >
        {allowedToReadEntity(auth?.permissions, permissionsAccessControl) && (
          <button
            className="btn btn-success"
            onClick={() => {
              showDeviceCategory(item);
            }}
          >
            <i className="bx bx-show"></i>
          </button>
        )}
        {allowedToUpdateEntity(auth?.permissions, permissionsAccessControl) && (
          <button
            className="btn btn-warning"
            onClick={() => {
              handleOpenPopup(isOpenPopup, item);
            }}
          >
            <i className="bx bx-edit"></i>
          </button>
        )}
        {allowedToDeleteEntity(auth?.permissions, permissionsAccessControl) && (
          <button className="btn btn-danger" onClick={() => handleDelete(item)}>
            <i className="bx bx-trash"></i>
          </button>
        )}
      </Box>
    ),
  };

  if (status === dataStateType.ACTIVE) {
    return [...columns, showHomeScreenCol, actionCol];
  }

  return columns;
};

export default GetCategoryColumns;
